export default {
  accountVerified: false,
  accountVerifiedMsg: "",
  organizationId: "",
  userId: "",
  quantumOrganizationId: "",
  quantumUserId: "",
  user: {},
  organizationDetails: {},
  token: "",
  quantumToken: "",
  env : process.env.NODE_ENV,
  accountType: {},
  accountUserType : "",
  google_api_key: process.env.VUE_GOOGLE_AUTOCOMPLETE_API_KEY
};
